import { createContext, useContext, useEffect, useState } from 'react'
import { useLocation, matchRoutes } from 'react-router-dom'
import { routes } from '../routes'

export default function DocumentTitleManager({ orgSettings, children }) {
  const location = useLocation()
  const [pageTitle, setPageTitle] = useState(null)

  useEffect(() => {
    // Clear a page-specific title when navigating
    setPageTitle(null)
  }, [location.pathname])

  useEffect(() => {
    if (location.pathname.startsWith('/docs')) {
      document.title = 'Docs | AmbuNet'
      return
    }

    const subdomain = window.location.hostname.split('.')[0]

    if (subdomain === 'crmadmin') {
      document.title = 'CRM Admin'
      return
    }

    const orgName =
      orgSettings?.orgSettings?.orgShortName ??
      orgSettings?.orgSettings?.orgName ??
      'AmbuNet'

    if (pageTitle) {
      document.title = `${pageTitle} | ${orgName}`
      return
    }

    const matches = matchRoutes(routes, location)

    if (matches?.length) {
      const title = matches[matches.length - 1]?.route?.title

      document.title = `${title ? `${title} | ` : ''}${orgName}`
    } else {
      document.title = 'AmbuNet'
    }
  }, [location, orgSettings, pageTitle])

  return (
    <DocumentTitleContext.Provider value={{ setPageTitle }}>
      {children}
    </DocumentTitleContext.Provider>
  )
}

export const DocumentTitleContext = createContext({
  setPageTitle: () => {}
})

export const useDocumentTitle = () => useContext(DocumentTitleContext)